module.exports = __webpack_public_path__ + "img/point-map.ac23777a.svg";